module.exports = __webpack_public_path__ + "static/media/likeActive.632a170f.svg";